export default "__VITE_ASSET__Cw9lMKYN__"